import { Alert, Order, Portfolio, Stock, User } from "../types/index";


const mockUsers: User[] = [
  { id: '1', email: 'demo@trader.com', password: 'password123', name: 'Demo Trader' },
];

const mockStocks: Stock[] = [
  { symbol: 'AAPL', name: 'Apple Inc.', price: 173.50, change: 2.45, changePercent: 1.43 },
  { symbol: 'GOOGL', name: 'Alphabet Inc.', price: 132.76, change: -1.23, changePercent: -0.92 },
  { symbol: 'MSFT', name: 'Microsoft Corp.', price: 378.85, change: 3.21, changePercent: 0.86 },
  { symbol: 'TSLA', name: 'Tesla Inc.', price: 248.42, change: -5.67, changePercent: -2.23 },
  { symbol: 'NVDA', name: 'NVIDIA Corp.', price: 875.28, change: 12.45, changePercent: 1.44 },
];

const mockPortfolio: Portfolio = {
  balance: 50000,
  totalValue: 67340.50,
  dayChange: 1245.30,
  dayChangePercent: 1.88,
  holdings: [
    { symbol: 'AAPL', shares: 50, avgPrice: 165.20, currentPrice: 173.50 },
    { symbol: 'MSFT', shares: 25, avgPrice: 370.00, currentPrice: 378.85 },
    { symbol: 'TSLA', shares: 30, avgPrice: 255.10, currentPrice: 248.42 },
  ],
};

export class MockTradingAPI {
  static async login(email: string, password: string): Promise<{ user: User; token: string }> {
    await new Promise(resolve => setTimeout(resolve, 500));
    const user = mockUsers.find(u => u.email === email && u.password === password);
    if (user) {
      const token = `mock-token-${Date.now()}`;
      sessionStorage.setItem('auth-token', token);
      sessionStorage.setItem('user', JSON.stringify(user));
      return { user, token };
    }
    throw new Error('Invalid credentials');
  }

  static async signup(email: string, password: string, name: string): Promise<{ user: User; token: string }> {
    await new Promise(resolve => setTimeout(resolve, 500));
    const newUser: User = { id: Date.now().toString(), email, password, name };
    mockUsers.push(newUser);
    const token = `mock-token-${Date.now()}`;
    sessionStorage.setItem('auth-token', token);
    sessionStorage.setItem('user', JSON.stringify(newUser));
    return { user: newUser, token };
  }

  static async getPortfolio(): Promise<Portfolio> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return mockPortfolio;
  }

  static async getStocks(): Promise<Stock[]> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockStocks.map(stock => ({
      ...stock,
      price: stock.price + (Math.random() - 0.5) * 2,
      change: stock.change + (Math.random() - 0.5) * 0.5,
    }));
  }

  static async placeOrder(order: Omit<Order, 'id' | 'status' | 'timestamp'>): Promise<Order> {
    await new Promise(resolve => setTimeout(resolve, 400));
    return {
      id: Date.now().toString(),
      ...order,
      status: Math.random() > 0.1 ? 'executed' : 'pending',
      timestamp: new Date().toISOString(),
    };
  }

  static async getOrders(): Promise<Order[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return JSON.parse(localStorage.getItem('mock-orders') || '[]') as Order[];
  }

  static async getAlerts(): Promise<Alert[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return JSON.parse(localStorage.getItem('mock-alerts') || '[]') as Alert[];
  }

  static async createAlert(alert: Omit<Alert, 'id' | 'created'>): Promise<Alert> {
    await new Promise(resolve => setTimeout(resolve, 300));
    const alerts = JSON.parse(localStorage.getItem('mock-alerts') || '[]') as Alert[];
    const newAlert: Alert = { id: Date.now().toString(), ...alert, created: new Date().toISOString() };
    alerts.push(newAlert);
    localStorage.setItem('mock-alerts', JSON.stringify(alerts));
    return newAlert;
  }

  static async deleteAlert(id: string): Promise<boolean> {
    await new Promise(resolve => setTimeout(resolve, 300));
    const alerts = JSON.parse(localStorage.getItem('mock-alerts') || '[]') as Alert[];
    const filtered = alerts.filter(alert => alert.id !== id);
    localStorage.setItem('mock-alerts', JSON.stringify(filtered));
    return true;
  }
}